export default class StatusModel {
    static getActive = () => [{name: 'Active', id: 'active'}, {name: 'Not Active', id: 'notActive'}];
}